import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { noAuthApi } from '../../../utils/axios';
import { config } from '../../../utils/config';
import SPORT_TYPES from '../../../utils/sportTypes';

import StandingsViewV2 from './StandingsViewV2';

const StandingsV2 = () => {
  const { selectedTournament } = useSelector((state) => state.tournament);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(false);

  // Initialize category
  useEffect(() => {
    if (selectedTournament?.categories?.length > 0 && !selectedCategory) {
      setSelectedCategory(selectedTournament.categories[0]);
    }
  }, [selectedTournament, selectedCategory]);

  // Fetch standings from API
  const fetchStandings = useCallback(async (tournamentId, categoryId) => {
    setLoading(true);
    try {
      const { data } = await noAuthApi.get(
        `/${config.API_PATH}/tournaments/${tournamentId}/categories/${categoryId}/standings`
      );
      setPhases(data.phases || []);
    } catch (err) {
      setPhases([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const tournamentId = selectedTournament?.id || selectedTournament?._id;
    const categoryId = selectedCategory?._id || selectedCategory?.id;
    if (!tournamentId || !categoryId) return;

    fetchStandings(tournamentId, categoryId);
  }, [selectedTournament, selectedCategory, fetchStandings]);

  const handleCategoryChange = (category) => {
    const cat = selectedTournament?.categories?.find(
      (c) => c.label === (category.label || category)
    );
    if (cat) setSelectedCategory(cat);
  };

  return (
    <StandingsViewV2
      phases={phases}
      loading={loading}
      selectedCategory={selectedCategory?.label || ''}
      selectedTournament={selectedTournament}
      sportType={selectedTournament?.sport || SPORT_TYPES.FOOTBALL}
      onCategoryChange={handleCategoryChange}
    />
  );
};

export default StandingsV2;
